// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/user/date.php
import F from 'offline/filter/constants'
export default {
	name: 'rating.user.date',
	priority: 67,
	require: function(config, filter) {
		return filter.rated && filter.rated.date && filter.rated.date.user && (filter.rated.date.user.from || filter.rated.date.user.to)
	},
	run: function(config, filter, data, query) {
		if (!config.userID) return
		var alias = 'r'
		if (config.ownerType !== F.OWNER_USER && config.resultType !== F.RESULT_RATING) {
			alias = 'ru'
			query.rename('r', 'ru')
		}
		query.where(alias + '.user_id', '=', config.userID)
		if (filter.rated.date.user.from) query.where(alias + '.rating_date', '>=', filter.rated.date.user.from)
		if (filter.rated.date.user.to) query.where(alias + '.rating_date', '<=', filter.rated.date.user.to)
	}
}
